module.exports = __webpack_public_path__ + "static/media/4.47ea7348.png";